<template>
  <Banner
    :bannerText="bannerContent.bannerText"
    :bannerTextAfter="bannerContent.bannerTextAfter"
    :bannerType="bannerContent.bannerType"
    :canCloseBanner="bannerContent.canCloseBanner"
    :emoji="bannerContent.emoji"
    :icon="bannerContent.icon"
    :learnMoreLink="bannerContent.learnMoreLink"
    :learnMoreText="bannerContent.learnMoreText"
    :showBanner="isVisible"
    @close="handleClose"
  >
    <template #content>
      <slot />
      <component
        :is="bannerContent.childComponent"
        v-if="bannerContent.childComponent"
      />
    </template>
  </Banner>
</template>

<script>
import { Banner } from '@jumpcloud/ui-components';
import BannerType from 'client/components/ViewportBanner/BannerType';
import LocalStorageService from 'client/util/LocalStorageService';

export default {
  name: 'BannerController',

  components: {
    Banner,
  },

  props: {
    bannerContent: {
      type: BannerType,
      required: true,
    },
  },

  data() {
    return {
      bannerOpen: true,
    };
  },

  computed: {
    isVisible() {
      const { canCloseBanner, localStorageKey, showBanner } = this.bannerContent;
      const { getValue } = this.$options.LocalStorageService;
      const showWithLocalStorage = canCloseBanner ? !getValue(localStorageKey) : true;

      return this.bannerOpen
        && showBanner
        && showWithLocalStorage;
    },
  },

  LocalStorageService,

  methods: {
    handleClose() {
      const { setItem } = this.$options.LocalStorageService;

      setItem(this.bannerContent.localStorageKey, true);
      this.bannerOpen = false;
    },
  },
};
</script>
